module.exports = __webpack_public_path__ + "img/icon-fain.984115b8.svg";